import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles'
import { validateInput } from '../../../../../../utils/input-validation'

const useStyles = makeStyles(theme => ({
	customTooltip: {
		fontSize: '1.00rem',
		whiteSpace: 'pre-line',
		textAlign: 'center',
	},
}))

export default function SubLabelType1({
	type,
	onFillForm,
	datasetId,
	answers,
	validationRules = {}
}) {
	const classes = useStyles()
	const answer = answers.find(item => item.DataSetItemID === datasetId)
	// const is5G = item.label.includes('5G');
	const is5G = false;

	const renderInput = (fieldName, value) => {
		// Override validation rules for Average column to allow float values
		let currentRules = validationRules
		if (fieldName === 'DataValueMonthAvg') {
			currentRules = { ...validationRules, dataType: 'float' }
		}

		const { isValid, message, status } = validateInput(value, currentRules)

		let bgClass = 'bg-green_input_bg'
		if (value && status === 'error') bgClass = 'bg-red-200 border-2 border-red-500'
		else if (value && status === 'warning') bgClass = 'bg-yellow-100 border-2 border-yellow-500'

		// START OF EDITS
		const handleBlur = (e) => {
			let val = e.target.value
			if (val.startsWith('.')) {
				val = '0' + val
			}

			// Use currentRules instead of validationRules to check dataType
			if (currentRules.dataType === 'float' && val !== '' && !isNaN(val)) {
				const parts = val.toString().split('.')
				const decimalLen = parts[1] ? parts[1].length : 0

				if (decimalLen < 2) {
					const formatted = parseFloat(val).toFixed(2)
					// Always compare with original event value to avoid unnecessary updates if logic didn't change anything semantically but string matches
					// But here we want to enforce formatting, so comparing against original input is correct
					if (formatted !== e.target.value) {
						onFillForm(type, datasetId, fieldName, formatted)
					}
				} else if (val !== e.target.value) {
					// Case where we just added '0' prefix e.g. .21 -> 0.21
					onFillForm(type, datasetId, fieldName, val)
				}
			}
		}
		// END OF EDITS

		return (
			<Tooltip classes={{ tooltip: classes.customTooltip }} title={message} arrow open={!!message && !!value}>
				<Input
					className={`border-r border-gray-500 w-3/12 p-1 font-bold text-center ${bgClass}`}
					value={value}
					onChange={e => {
						onFillForm(type, datasetId, fieldName, e.target.value)
					}}
					onBlur={handleBlur}
					type="text"
					error={status === 'error' && !!value}
				/>
			</Tooltip>
		)
	}

	return (
		<Grid className="col-span-12 text-center border flex flex-row justify-around">
			{/* Months */}
			{renderInput('DataValueMonth1', answer?.DataValueMonth1)}
			{renderInput('DataValueMonth2', answer?.DataValueMonth2)}

			{!is5G ? (
				renderInput('DataValueMonth3', answer?.DataValueMonth3)
			) : (
				<></>
			)}
			{/* Average */}
			{!is5G ? (
				renderInput('DataValueMonthAvg', answer?.DataValueMonthAvg)
			) : (
				<></>
			)}
		</Grid>
	)
}
